import CheckNewOrders from "../symbols/checkNewOrdersQueued";
import { HttpRequestPost } from "../../service";

const checkNewOrdersQueuedAction = () => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_QUEUED,
});
const checkNewOrdersQueuedSuccessAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_QUEUED_SUCCESS,
  payload: data,
});
const checkNewOrdersQueuedFailureAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_QUEUED_FAILURE,
  payload: data,
});
const clearCheckNewOrdersQueuedAction = () => ({
  type: CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_QUEUED,
});
export function getCheckNewOrdersQueued(
  Date: string,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    dispatch(checkNewOrdersQueuedAction());
    HttpRequestPost(
      "/order/check-new/queued",
      dispatch,
      checkNewOrdersQueuedSuccessAction,
      checkNewOrdersQueuedFailureAction,
      true,
      { Date },
      callback
    );
  };
}

export function clearCheckNewOrdersQueued() {
  return (dispatch: any) => {
    dispatch(clearCheckNewOrdersQueuedAction());
  };
}
